export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'yyyy-MM-dd HH:mm';
export const DAY_FORMAT = 'yyyy-MM-dd';
export const DAYTIME_FORMAT = 'YYYY-MM-DD HH:mm';
